import { Component, computed, input, ChangeDetectionStrategy } from "@angular/core";

@Component({
    selector:'button[app-btn] , a[app-btn]',
    standalone:true,
    template:'<ng-content/>',
    styleUrl:'./standard-button.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    host: {
        '[class]': 'hostClasses()'
    }
})
export class StandardButtonComponent{
    variant = input<'primary' | 'tertiary' | 'secondary' | 'quaternary'>('primary');
    size = input<'sm'|'smd'|'xsm'|'md'|'xmd'|'lg'>('md');
    pill = input<'pill' | 'nopill'>('nopill');
    height = input<string>();
    customClass = input<string>('');

    hostClasses = computed(() => {
        const classes = [
            `btn-${this.variant()}`,
            `btn-${this.size()}`,
        ];
        if (this.pill() === 'pill') classes.push('btn-pill');
        if (this.customClass()) classes.push(this.customClass());
        return classes.join(' ');
    });
}